"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoNeedUpgradeError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../common/localizeUtils");
class NoNeedUpgradeError extends teamsfx_api_1.UserError {
    constructor() {
        super({
            message: localizeUtils_1.getDefaultString("error.upgrade.NoNeedUpgrade"),
            displayMessage: localizeUtils_1.getLocalizedString("error.upgrade.NoNeedUpgrade"),
            source: "upgrade",
        });
    }
}
exports.NoNeedUpgradeError = NoNeedUpgradeError;
//# sourceMappingURL=upgrade.js.map